/**
 * Canonical site origin — the ONLY place the production URL is defined.
 * Every share link, canonical tag, and JSON-LD reference should import
 * `SITE_URL` from here so preview/staging hosts can never leak into
 * outbound URLs (see bug: social share links pointed at bsofms.lovable.app).
 */
export const SITE_URL = "https://myelinahealth.com";

/**
 * Hosts that are legacy aliases or `www.` forms of the canonical domain.
 * Kept in sync with the redirect script in index.html.
 */
const ALIAS_HOST = /^(www\.)?(myelina\.health|myelina\.net|myelina\.org|myelinahealth\.net|myelinahealth\.org|myelinahealth\.com)$/i;

/**
 * Origin to use for auth email links (verification, password reset, magic
 * links). On any production alias (www.myelinahealth.com, myelina.health, ...)
 * this returns the canonical https://myelinahealth.com so the link in the
 * user's inbox never points at a host that only redirects. On localhost and
 * preview hosts it returns the current origin so testing still works.
 */
export function authOrigin(): string {
  if (typeof window === "undefined") return SITE_URL;
  return ALIAS_HOST.test(window.location.hostname) ? SITE_URL : window.location.origin;
}

/** Absolute auth redirect URL for `path` (e.g. "/reset-password"). */
export function authRedirectUrl(path = "/"): string {
  return `${authOrigin()}${path === "/" ? "" : path}`;
}
